import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Modal from '@/components/base/Modal/Modal.vue';
// client js begin
import { markRead } from '@/services/magicService';
// client js end

export default {
  props: {
    wording: {
      type: [Object, undefined],
      required: true
    }
  },
  components: {
    Modal: Modal,
    SvgIcons: function SvgIcons() {
      return import('@tencent/vft-ui/src/SvgIcons/SvgIcons.vue');
    }
  },
  computed: {
    wordingPic: function wordingPic() {
      return this.wording && this.wording.mpExpansion.type_246_gift_icon;
    },
    wordingTitle: function wordingTitle() {
      return this.wording && this.wording.sTitle;
    },
    url: function url() {
      return this.wording.tActType.sH5Url;
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    clickWording: function clickWording() {
      if (this.wording.tActType.sActType !== 'welfare' && this.url) {
        this.openUrl(this.url);
        markRead(this.wording.sActID);
      }
    }
  },
  reportData: {
    'wording': {
      'f_module': '专属福利',
      'f_resource': 'wording',
      'f_type': 5
    }
  }
};